import React from 'react';

/**
 * Suspense fallback for lazily-loaded page chunks.
 * Mirrors the existing "Carregando loja…" content placeholder style
 * (see pages.jsx useTenantFromUrl) so the shell (sidebar/topbar) never flashes.
 */
export function ContentLoadingFallback({ label = 'Carregando…' }) {
  return (
    <div
      className="content"
      style={{
        padding: 40,
        textAlign: 'center',
        color: 'var(--text-muted)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 12,
      }}
      role="status"
      aria-live="polite"
    >
      <span
        aria-hidden="true"
        style={{
          width: 22,
          height: 22,
          borderRadius: '50%',
          border: '2px solid var(--border, #e5e7eb)',
          borderTopColor: 'var(--primary, #4f46e5)',
          animation: 'sa-route-spin 0.8s linear infinite',
        }}
      />
      <span style={{ fontSize: 13 }}>{label}</span>
      <style>{'@keyframes sa-route-spin { to { transform: rotate(360deg); } }'}</style>
    </div>
  );
}
